import _ from 'lodash'

import { BlindMatchStatus } from './types'

export interface ComputeStatusInput {
  sourceValue: any
  typedValue: string | undefined
  showUnavailableOnEmptySource?: boolean
}

export interface ComputedStatus {
  status: BlindMatchStatus
  verified: boolean | undefined
}

export function computeBlindMatchStatus(input: ComputeStatusInput): ComputedStatus {
  const { sourceValue, typedValue, showUnavailableOnEmptySource = true } = input

  if (_.isNil(sourceValue) || sourceValue === '') {
    if (showUnavailableOnEmptySource && !_.isNil(sourceValue)) {
      return { status: BlindMatchStatus.Unavailable, verified: undefined }
    }
    if (showUnavailableOnEmptySource) {
      return { status: BlindMatchStatus.Unavailable, verified: undefined }
    }
    return { status: BlindMatchStatus.Precheck, verified: undefined }
  }

  if (!typedValue) {
    return { status: BlindMatchStatus.Precheck, verified: undefined }
  }

  if (_.isEqual(_.toLower(String(typedValue)), _.toLower(String(sourceValue)))) {
    return { status: BlindMatchStatus.Verified, verified: true }
  }

  return { status: BlindMatchStatus.Failed, verified: false }
}
